import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const cases = [
  {
    tag: "超離子換膚術",
    result: "疤痕修復完成度 96%",
    color: "from-pink-50 to-pink-100",
    img: "https://readdy.ai/api/search-image?query=Before%20and%20after%20medical%20skin%20treatment%20result%20on%20female%20cheek%20area%20showing%20smoother%20clearer%20skin%2C%20clean%20clinical%20photography%2C%20soft%20natural%20light%2C%20warm%20cream%20background%2C%20professional%20dermatology%20editorial&width=700&height=700&seq=ishb-case-1&orientation=squarish",
  },
  {
    tag: "超離子換膚術",
    result: "紅痘修復完成度 97%",
    color: "from-rose-50 to-rose-100",
    img: "https://readdy.ai/api/search-image?query=Before%20and%20after%20clinical%20result%20photo%20of%20female%20face%20cheek%20acne%20redness%20treatment%20improvement%2C%20clean%20professional%20dermatology%20photography%2C%20warm%20natural%20light%2C%20soft%20cream%20background&width=700&height=700&seq=ishb-case-2&orientation=squarish",
  },
  {
    tag: "超離子換膚術",
    result: "皮膚病修復完成度 99.6%",
    color: "from-emerald-50 to-emerald-100",
    img: "https://readdy.ai/api/search-image?query=Clinical%20medical%20hand%20skin%20treatment%20before%20and%20after%20result%20photo%20showing%20clearer%20smoother%20skin%2C%20professional%20dermatology%20editorial%20photography%2C%20soft%20natural%20light%2C%20warm%20cream%20background&width=700&height=700&seq=ishb-case-3&orientation=squarish",
  },
  {
    tag: "超離子換膚術",
    result: "清除痣完成度 99.8%",
    color: "from-amber-50 to-amber-100",
    img: "https://readdy.ai/api/search-image?query=Clinical%20before%20and%20after%20result%20photo%20of%20facial%20mole%20removal%20treatment%20on%20cheek%20area%2C%20smooth%20clear%20skin%20result%2C%20professional%20dermatology%20editorial%20photography%2C%20warm%20natural%20light%2C%20soft%20cream%20background&width=700&height=700&seq=ishb-case-4&orientation=squarish",
  },
  {
    tag: "超離子換膚術",
    result: "妊娠紋修復完成度 98%",
    color: "from-lime-50 to-lime-100",
    img: "https://readdy.ai/api/search-image?query=Close-up%20clinical%20dermatology%20photo%20of%20lower%20abdomen%20skin%20showing%20visible%20reddish%20stretch%20marks%20striae%20lines%20with%20smoother%20treated%20skin%20result%2C%20before%20and%20after%20medical%20treatment%20comparison%2C%20warm%20natural%20light%2C%20clean%20soft%20cream%20background%2C%20professional%20medical%20aesthetic%20editorial%20photography&width=700&height=700&seq=ishb-case-5&orientation=squarish&nocache=true",
  },
  {
    tag: "超離子換膚術",
    result: "耳部瘢痕修復完成度 95%",
    color: "from-sky-50 to-sky-100",
    img: "https://readdy.ai/api/search-image?query=Clinical%20before%20and%20after%20result%20photo%20of%20ear%20area%20keloid%20scar%20treatment%20showing%20smoother%20skin%2C%20professional%20medical%20aesthetic%20editorial%20photography%2C%20warm%20natural%20light%2C%20soft%20cream%20background&width=700&height=700&seq=ishb-case-6&orientation=squarish",
  },
];

export default function Cases() {
  return (
    <div className="min-h-screen bg-white text-brand-900">
      <Navbar />

      <section className="pt-32 md:pt-40 pb-16 md:pb-20 bg-brand-50/60">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="inline-block px-6 py-2 rounded-md bg-brand-600 text-white text-lg tracking-wider">真實案例分享</div>
          <h1 className="mt-6 font-serif text-3xl md:text-5xl text-brand-800">尊屬案例見證</h1>
          <p className="mt-4 text-brand-700/70 max-w-2xl text-sm md:text-base">
            超過十萬名學員與顧客的真實見證，每一個修復數據，都是我們對「安全與效果」的承諾。
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cases.map((c) => (
              <div key={c.result} className={`rounded-xl overflow-hidden bg-gradient-to-br ${c.color} p-4 border border-white`}>
                <div className="relative rounded-lg overflow-hidden">
                  <img src={c.img} alt={c.result} className="w-full h-56 md:h-64 object-cover object-top" />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/85 text-xs font-medium text-rose-600 whitespace-nowrap">
                    {c.tag}
                  </span>
                </div>
                <div className="pt-4 pb-2 px-1 flex items-center justify-between">
                  <span className="text-brand-800 font-medium">{c.result}</span>
                  <a href="/#join" className="text-brand-600 hover:text-brand-700 text-sm whitespace-nowrap cursor-pointer">
                    查看細節 →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}